import logo_headline from './headline'
import logo_headline_white from './headline-white'

// livegift è una vetrina VadoBay: i loghi sono gli stessi del brand vadobay.com
export {
  logo_headline,
  logo_headline_white
}